import { render, staticRenderFns } from "./MenuUl.vue?vue&type=template&id=6d86f0ab&scoped=true"
import script from "./MenuUl.vue?vue&type=script&lang=js"
export * from "./MenuUl.vue?vue&type=script&lang=js"
import style0 from "./MenuUl.vue?vue&type=style&index=0&id=6d86f0ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86f0ab",
  null
  
)

export default component.exports